import {TranslationFunction} from "../../../i18n/i18n";
import {CatalogFormatter} from "../../../common/catalog/CatalogFormatter";
import {FormSessionPrefillRequestStateType} from "../../../client/formsession/FormSessionApiClient";

export class PrefillRequestStateFormatter {
    static formatPrefillRequestState(prefilRequestState: FormSessionPrefillRequestStateType | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(prefilRequestState, "prefillRequestState", t);
    }
}
